import React from "react"

  // <RadioSelect value={tpc.value} options={tpc.options} onChange={tp.onProductTableUpdate} />
  // HandleChange will set thevalue above as required
  // Values - either none or single value selected, no "clear" option

export class RadioSelect extends React.Component {
    constructor(props){
        super(props)
        this.state = { selectedOption: this.props.value }
        this.handleChange = this.handleChange.bind(this)
    }
    //handleChange = event => {};
    handleChange = changeEvent => {
      this.setState({selectedOption: changeEvent.target.value})
      this.props.onChange(changeEvent)
    }
    
    render() {
      
      const RadioOption = props => { 
        let spanStyle = "input-radio" + ((props.value === props.selectedValue) ? " ir-bolder" : "")
        return (<div className="radio-option-item">
                                <input
                                    type = "radio"
                                    key = {props.mykey}
                                    // id  = {this.state.id}
                                    name = {props.name}
                                    value = {props.value}
                                    checked = {props.value === props.selectedValue}
                                    onChange = {props.onChange}
                                  /> 
                                  <span className={spanStyle}>{props.value}</span>
                            </div>)
        }
      const {options, name } = this.props
      var cName = ""
      if (options.length > 4)
            cName = "radio-select-options options-full-width" 
      else  cName = "radio-select-options"

      return (
            <div className={cName}>
                {options.map ((item, index) => 
                  <RadioOption
                  key = {index}
                      mykey = {index}
                      name={name}
                      // id = {this.state.id}
                      value={item}
                      selectedValue={this.state.selectedOption}
                      onChange= {this.handleChange} > 
                      {item}
                  </RadioOption>
                  )
                }
            </div>
      )
    }
  }
  